export const vision =
  'Indigenous communities worldwide have the digital tools to exercise full self-determination over their data, decisions, and development — on their own terms.'

export const mission =
  'Matou Collective designs and builds Indigenous digital infrastructure and tooling to support community collaboration, governance and growth.'

export const missionContext = [
  { label: 'Team', value: '5 active contributors' },
  { label: 'Funding', value: 'Runway to end of 2026' },
  { label: 'Scope', value: 'Global Indigenous from day one' },
  { label: 'Approach', value: 'Off-chain first, progressive decentralisation' },
]
